import { images } from "@/public";
import Image from "next/image";
import React from "react";

function Advertisement() {
  return (
    <div className="w-full h-[400px] border-l border-white/10 flex flex-col items-center justify-center bg-gradient-to-b from-theme-primary/5 to-transparent">
      <div className="w-full flex flex-col items-center justify-center">
        <Image
          width={500}
          height={500}
          src={images.Advertise1}
          alt="Advertisement"
          className="object-contain w-[264px] h-auto rounded-sm border border-white/20 bg-gray-200"
        />
        <p className="text-xs text-gray-700 font-medium mt-3 text-center">Sponsored</p>
      </div>
    </div>
  );
}

export default Advertisement;
